// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyANTre0i_2mGgADFQSlnorG8Chw9K8vJ3k",
  authDomain: "songaudit.firebaseapp.com",
  databaseURL: "https://songaudit-default-rtdb.europe-west1.firebasedatabase.app/",
  projectId: "songaudit",
  storageBucket: "songaudit.firebasestorage.app",
  messagingSenderId: "1006380803145",
  appId: "1:1006380803145:web:887ee3f270a60f79fd8b98"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const realtimeDb = getDatabase(app);

export default app; 